var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyobcom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 21.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -7.2,
    x2: 24.2,
    y1: 35.7,
    y2: 35.7,
    gradientTransform: "matrix(1.02 0 0 -1.02 7.3 47.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6100a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7001a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d9057e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed0677"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M16 3a8.4 8.4 0 0 0-6.6-3A9 9 0 0 0 0 9.3v12h1.8c1.1 0 3.5-.6 3.6-4V9.2a3.8 3.8 0 0 1 4-4 3.6 3.6 0 0 1 4 4v12.2H15c1.1 0 3.5-.7 3.6-4V9.1a3.9 3.9 0 0 1 4-4 3.7 3.7 0 0 1 4 4v12.2h1.7c1.2 0 3.6-.7 3.6-4.2V9.3C32 3.8 28.6 0 22.7 0a8.7 8.7 0 0 0-6.6 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyobcom);
export default __webpack_public_path__ + "static/media/myob.com.876af4f923f145ed43b5f619ca600296.svg";
export { ForwardRef as ReactComponent };